import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { apiUrl } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  constructor(private http: HttpClient) { }

  getAuthHeader() {
    return {
      headers: new HttpHeaders({
        'Authorization': localStorage.getItem('cn035')
      })
    };
  }

  getByQuestionnaireApplication(id, limit, offset) {
    if (limit !== null) {
      return this.http.get(`${apiUrl}/employee/questionnaireapplication/${id}?limit=${limit}&offset=${offset}&order=0`, this.getAuthHeader()).toPromise()
        .then(res => res)
        .catch(err => err.error);
    } else {
      return this.http.get(`${apiUrl}/employee/questionnaireapplication/${id}`, this.getAuthHeader()).toPromise()
        .then(res => res)
        .catch(err => err.error);
    }
  }

  getByApplicationEmail(id, q_email, limit, offset) {
    if (limit !== null) {
      return this.http.get(`${apiUrl}/employee/questionnaireapplication/${id}/applicationemail?application_email=${q_email}&limit=${limit}&offset=${offset}&order=0`, this.getAuthHeader())
      .toPromise()
      .then(res => res)
      .catch(err => err.error);
    } else {
      return this.http.get(`${apiUrl}/employee/questionnaireapplication/${id}/applicationemail?application_email=${q_email}`, this.getAuthHeader())
      .toPromise()
      .then(res => res)
      .catch(err => err.error);
    }
  }

  getByName(id, q_name, limit, offset) {
    if (limit !== null) {
      return this.http.get(`${apiUrl}/employee/questionnaireapplication/${id}/name?name=${q_name}&limit=${limit}&offset=${offset}&order=0`, this.getAuthHeader())
      .toPromise()
      .then(res => res)
      .catch(err => err.error);
    } else {
      return this.http.get(`${apiUrl}/employee/questionnaireapplication/${id}/name?name=${q_name}`, this.getAuthHeader())
      .toPromise()
      .then(res => res)
      .catch(err => err.error);
    }
  }

  getByAnswerStatus(id, q_status, limit, offset) {
    if (limit !== null) {
      return this.http.get(`${apiUrl}/employee/questionnaireapplication/${id}/answerstatus?answer_status_id=${q_status}&limit=${limit}&offset=${offset}&order=0`, this.getAuthHeader())
        .toPromise()
        .then(res => res)
        .catch(err => err.error);
    } else {
      return this.http.get(`${apiUrl}/employee/questionnaireapplication/${id}/answerstatus?answer_status_id=${q_status}`, this.getAuthHeader())
        .toPromise()
        .then(res => res)
        .catch(err => err.error);
    }
  }

  getById(id) {
    return this.http.get(`${apiUrl}/employee/${id}`, this.getAuthHeader()).toPromise()
      .then(res => res)
      .catch(err => err.error);
  }

  getGenders() {
    return this.http.get(`${apiUrl}/employee/genders`, this.getAuthHeader()).toPromise()
      .then(res => res)
      .catch(err => err.error);
  }

  getAges() {
    return this.http.get(`${apiUrl}/employee/ages`, this.getAuthHeader()).toPromise()
      .then(res => res)
      .catch(err => err.error);
  }

  getCivilStatuses() {
    return this.http.get(`${apiUrl}/employee/civilstatuses`, this.getAuthHeader()).toPromise()
      .then(res => res)
      .catch(err => err.error);
  }

  getEducationLevels() {
    return this.http.get(`${apiUrl}/employee/educationlevels`, this.getAuthHeader()).toPromise()
      .then(res => res)
      .catch(err => err.error);
  }

  getPositionTypes() {
    return this.http.get(`${apiUrl}/employee/positiontypes`, this.getAuthHeader()).toPromise()
      .then(res => res)
      .catch(err => err.error);
  }

  getRecruitmentTypes() {
    return this.http.get(`${apiUrl}/employee/recruitmenttypes`, this.getAuthHeader()).toPromise()
      .then(res => res)
      .catch(err => err.error);
  }

  getEmployeeTypes() {
    return this.http.get(`${apiUrl}/employee/employeetypes`, this.getAuthHeader()).toPromise()
      .then(res => res)
      .catch(err => err.error);
  }

  getWorkingHoursTypes() {
    return this.http.get(`${apiUrl}/employee/workinghourstypes`, this.getAuthHeader()).toPromise()
      .then(res => res)
      .catch(err => err.error);
  }

  getWorkingHoursRotations() {
    return this.http.get(`${apiUrl}/employee/workinghoursrotations`, this.getAuthHeader()).toPromise()
      .then(res => res)
      .catch(err => err.error);
  }

  getWorkExperiences() {
    return this.http.get(`${apiUrl}/employee/workexperiences`, this.getAuthHeader()).toPromise()
      .then(res => res)
      .catch(err => err.error);
  }

  getWorkCurrentPositionTimes() {
    return this.http.get(`${apiUrl}/employee/currentpositiontimes`, this.getAuthHeader()).toPromise()
      .then(res => res)
      .catch(err => err.error);
  }

  getAnswerStatuses() {
    return this.http.get(`${apiUrl}/employee/answerstatuses`, this.getAuthHeader()).toPromise()
      .then(res => res)
      .catch(err => err.error);
  }

  getStates() {
    return this.http.get(`${apiUrl}/employee/states`, this.getAuthHeader()).toPromise()
      .then(res => res)
      .catch(err => err.error);
  }

  post(data) {
    return this.http.post(`${apiUrl}/employee/`, data, this.getAuthHeader()).toPromise()
      .then(res => res)
      .catch(err => err.error);
  }

  upload(data) {
    return this.http.post(`${apiUrl}/employee/upload/`, data, this.getAuthHeader()).toPromise()
      .then(res => res)
      .catch(err => err.error);
  }

  patchById(id, data) {
    return this.http.patch(`${apiUrl}/employee/${id}`, data, this.getAuthHeader()).toPromise()
      .then(res => res)
      .catch(err => err.error);
  }

  deleteById(id) {
    return this.http.delete(`${apiUrl}/employee/${id}`, this.getAuthHeader()).toPromise()
      .then(res => res)
      .catch(err => err.error);
  }

  sendMail(id, body) {
    return this.http.post(`${apiUrl}/employee/${id}/send`, body, this.getAuthHeader()).toPromise()
      .then(res => res)
      .catch(err => err.error);
  }
}
